import React from "react";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import config from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

export default function InfiHybridEwallet() {
  const navigate = useNavigate();
  // const loginDetails = useSelector((state) => state.auth.LoginDetails);

  return (
    <>
      <section className="Security position-relative pt-0 pb-0">
        <Container className="py-5 position-relative">
          <Row className="justify-content-center align-items-center py-2">
            <Col lg={12} className="pb-5 security-card">
              <div className="bookshap">
                <img src="images/book.png" alt="" />
              </div>
              <Card className="bg-transparent border border-dark p-5">
                <Row className="justify-content-center">
                  <Col xl={12} lg={10}>
                    <div className="security-detail p-md-5 pt-5">
                      <h1 className="text-white mb-4 text-center">
                        INFI Hybrid eWallet&nbsp;
                        <span className="fw-normal">
                          - INFI Vault <p className="fs-3 mt-2">A Secure and Seamless Environment for Digital Asset Management</p>
                        </span>
                      </h1>
                      <p className="text-light-grey2 fs-5">
                        Access your digital assets through the INFI Hybrid eWallet – INFI Vault, a secure and
                        decentralised environment designed for ease of use, efficiency, and privacy. Powered by the <strong>SbSe
                          Safe Track</strong> protocol, it supports user autonomy and frictionless value transfers within a multichain ecosystem. Integrated activity-based features reward engagement on key actions like
                        sending, receiving, and swapping assets.
                      </p>
                      <ul className="list-unstyled ps-0 mb-0">
                        <li className="text-light-grey2 mb-2">
                          <span className="text-white">
                            ✅ Fast & Cost-Efficient Swaps –
                          </span>{" "}
                          – Perform on-chain transactions with optimized speed and
                          minimal network fees.
                        </li>
                        <li className="text-light-grey2 mb-2">
                          <span className="text-white">
                            ✅ Multi-Chain Connectivity
                          </span>{" "}
                          – Seamlessly interact with digital assets across six supported
                          blockchain networks.
                        </li>
                        <li className="text-light-grey2 mb-2">
                          <span className="text-white">
                            ✅ User-Centric & Decentralised
                          </span>{" "}
                          – Retain full access and control over your assets with no
                          third-party custody.
                        </li>
                        <li className="text-light-grey2 mb-2">
                          <span className="text-white">
                            ✅ Integrated Digital Utility Hub
                          </span>{" "}
                          – Connect blockchain-based tools with select off-chain
                          services for unified access.
                        </li>
                        <li className="text-light-grey2">
                          <span className="text-white">
                            ✅ Smart Risk Filters
                          </span>{" "}
                          – The system includes automated tools to support safe transaction patterns
                          and flag unusual behavior, helping preserve network integrity without compromising privacy.
                        </li>
                      </ul>
                    </div>
                    <div className="buyInfi">
                      <Button
                        variant="white-gradient"
                        className="btn-white-gradient text-black px-4 rounded-5 position-relative z-2"
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <div className="lh-1">
                            eWallet
                            <div className="text-success text-uppercase x-small">
                              (coming soon {" "})
                              {/* Q4 2024 - Q4 2025) */}
                            </div>
                          </div>
                          <div>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="16"
                              viewBox="0 0 24 19"
                              fill="none"
                            >
                              <path
                                d="M15.7909 1.36816L22.6717 9.49995M22.6717 9.49995L15.7909 17.6317M22.6717 9.49995L1.32571 9.49995"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Container>
        <div className="bg-shape3 ">
          <img src="images/bg-shape3.png" alt="" />
        </div>
      </section>
    </>
  );
}
